```vue
<template>
  <div class="benefits-area pt-100">
    <div class="container mw-1356">
      <div class="row">
        <div
          class="col-xl-6"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="100"
        >
          <div class="benefits-img">
            <img src="@/assets/images/benefits.png" alt="benefits" />
            <div class="review mb-minus-53">
              <div class="review-in">
                <span>سنوات الخبرة</span>
                <h1>{{ experienceYears }} سنوات</h1>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-6">
          <div class="benefits-content">
            <span class="top-title">المميزات</span>
            <h2 class="text-white">مزايا حقيقية لك</h2>

            <div class="row">
              <div
                v-for="(benefit, index) in benefits"
                :key="index"
                class="col-lg-6"
                data-aos="fade-up"
                data-aos-duration="1000"
                :data-aos-delay="200 + (index % 2) * 100"
              >
                <div class="d-flex benefits-single-item">
                  <div class="flex-shrink-0">
                    <i :class="benefit.icon"></i>
                  </div>
                  <div class="flex-grow-1 ms-3">
                    <h3>{{ benefit.title }}</h3>
                    <p>{{ benefit.description }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "OnlyBenefits",
  setup() {
    const experienceYears = ref(10);

    const benefits = ref([
      {
        icon: "flaticon-antena",
        title: "قنوات مميزة",
        description:
          "استمتع بأفضل القنوات التلفزيونية مع تجربة بث عالية الجودة.",
      },
      {
        icon: "flaticon-wifi-router",
        title: "اتصال سريع",
        description:
          "بعد الاشتراك، تحصل على بيانات الدخول وتبدأ باستخدام الخدمة بسهولة.",
      },
      {
        icon: "flaticon-24-hours",
        title: "دعم فني",
        description: "احصل على دعم فني لمساعدتك عند الحاجة.",
      },
      {
        icon: "flaticon-privacy-policy",
        title: "خصوصية وأمان",
        description:
          "نحرص على حماية بياناتك وتقديم تجربة استخدام آمنة وموثوقة.",
      },
      {
        icon: "flaticon-smart-tv",
        title: "تثبيت بسيط",
        description:
          "لا تحتاج إلى خبرة تقنية، فقط حمّل التطبيق على جهازك واتبع التعليمات البسيطة.",
      },
      {
        icon: "flaticon-best-price",
        title: "أفضل الباقات",
        description:
          "باقات مناسبة بأسعار منافسة وجودة مشاهدة عالية.",
      },
    ]);

    return {
      experienceYears,
      benefits,
    };
  },
});
</script>
```
